import classNames from 'classnames'
import { Select } from 'baseui/select'
import React, { useEffect, useState } from 'react'
import { Button, WemoloTypography } from '../../../components/Wemolo'
import { SliderComponentSingle } from '../../../components/Slider'
import styles from './Control.module.css'

export const Control: React.FC<{
    max: number
    value: number
    setValue: (value: number) => void
    label: string
    min: number
    width?: string
    step?: number
    fullscreen?: boolean
    disabled?: boolean
    multipliers?: number[]
}> = ({
    max,
    value,
    setValue,
    label,
    min = 0,
    width = '40%',
    fullscreen = false,
    disabled = false,
    step = 10,
    multipliers = [1, 5, 20]
}) => {
    const [stepMultiplier, setStepMultiplier] = useState<number>(multipliers?.[multipliers.length - 1])
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const showButtons = fullscreen || windowWidth > 1700

    return (
        <div className={classNames(styles.root, { [styles.fullscreen]: fullscreen })} style={{ width }}>
            <WemoloTypography variant="label-medium" tag="label" className={styles.label}>
                {label}
            </WemoloTypography>
            <div className={classNames(styles.sliderRow, { [styles.fullscreen]: fullscreen })}>
                <SliderComponentSingle
                    transparentBackground={true}
                    disabled={disabled}
                    max={max}
                    step={step}
                    value_view={value}
                    setValue={setValue}
                    sliderGuidelines={true}
                />
            </div>
            <div className={styles.buttonsRow}>
                <Button
                    size="small"
                    disabled={disabled || value <= min}
                    onClick={() => setValue(Math.max(min, value - step * stepMultiplier))}
                >
                    <i className={`${styles.iconButton} material-icons`}>remove</i>
                </Button>
                {showButtons ? (
                    <div className={styles.multipliers}>
                        {multipliers.map((multiplier) => (
                            <div
                                key={multiplier}
                                onClick={() => !disabled && setStepMultiplier(multiplier)}
                                className={classNames(styles.multiplier, {
                                    [styles.active]: stepMultiplier === multiplier,
                                    [styles.disabled]: disabled
                                })}
                            >
                                {multiplier * step}
                            </div>
                        ))}
                    </div>
                ) : (
                    <Select
                        disabled={disabled}
                        options={multipliers.map((multiplier) => ({
                            label: `${multiplier * step}`,
                            id: multiplier
                        }))}
                        value={[{ label: `${stepMultiplier * step}`, id: stepMultiplier }]}
                        onChange={(params) => {
                            if (params.value[0]) {
                                setStepMultiplier(params.value[0].id as number)
                            }
                        }}
                        overrides={{
                            Root: {
                                style: {
                                    width: '60px'
                                }
                            }
                        }}
                        clearable={false}
                        searchable={false}
                        size="mini"
                    />
                )}
                <Button
                    size="small"
                    disabled={disabled || value >= max}
                    onClick={() => setValue(Math.min(max, value + step * stepMultiplier))}
                >
                    <i className={`${styles.iconButton} material-icons`}>add</i>
                </Button>
            </div>
        </div>
    )
}
